import React, { useState, useEffect } from 'react';
import { Link } from 'react-scroll';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import logo from '../assets/images/smg_logo.png';
import './Header.css';
import IconWrapper from './IconWrapper';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <header className={`header ${scrolled || !isHomePage ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-container">
          <div className="logo-bubble">
            <img src={logo} alt="The Collective at Gateway Logo" className="logo" />
          </div>
        </div>

        <div className="mobile-menu-toggle" onClick={toggleMenu}>
          {isOpen ? <IconWrapper icon={FaTimes} /> : <IconWrapper icon={FaBars} />}
        </div>

        <nav className={`nav-menu ${isOpen ? 'active' : ''}`}>
          <ul className="nav-links">
            <li>
              {isHomePage ? (
                <Link to="home" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Home
                </Link>
              ) : (
                <RouterLink to="/" onClick={() => setIsOpen(false)}>
                  Home
                </RouterLink>
              )}
            </li>
            <li>
              <RouterLink to="/conference-room" onClick={() => setIsOpen(false)}>
                Conference Room
              </RouterLink>
            </li>
            <li>
              {isHomePage ? (
                <Link to="spaces" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Spaces
                </Link>
              ) : (
                <RouterLink to="/#spaces" onClick={() => setIsOpen(false)}>
                  Spaces
                </RouterLink>
              )}
            </li>
            <li>
              {isHomePage ? (
                <Link to="amenities" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Amenities
                </Link>
              ) : (
                <RouterLink to="/#amenities" onClick={() => setIsOpen(false)}>
                  Amenities
                </RouterLink>
              )}
            </li>
            <li>
              {isHomePage ? (
                <Link to="gallery" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Gallery
                </Link>
              ) : (
                <RouterLink to="/#gallery" onClick={() => setIsOpen(false)}>
                  Gallery
                </RouterLink>
              )}
            </li>
            <li>
              {isHomePage ? (
                <Link to="broker-compensation" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Broker Program
                </Link>
              ) : (
                <RouterLink to="/#broker-compensation" onClick={() => setIsOpen(false)}>
                  Broker Program
                </RouterLink>
              )}
            </li>
            <li>
              {isHomePage ? (
                <Link to="contact" smooth={true} duration={500} onClick={() => setIsOpen(false)}>
                  Contact
                </Link>
              ) : (
                <RouterLink to="/#contact" onClick={() => setIsOpen(false)}>
                  Contact
                </RouterLink>
              )}
            </li>
          </ul>
        </nav>

        <div className="header-contact">
          <a href="tel:+16503023011" className="phone-link">
            <IconWrapper icon={FaPhone} /> (650) 302-3011
          </a>
          {isHomePage ? (
            <Link to="contact" smooth={true} duration={500} className="contact-btn">
              Schedule a Tour
            </Link>
          ) : (
            <RouterLink to="/#contact" className="contact-btn">
              Schedule a Tour
            </RouterLink>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header; 